import React, { Component } from "react";
import TeamWeek from "../../../components/TeamWeek/TeamWeek";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : LicensesForm
Description : Compoente que alberga el formulario de Licenses definido en el directorio de componentes
Date Autor Modification
================================================================================
29/09/2022 Santiago Coca - Se define el componente
================================================================================ */

class TeamWeekForm extends Component {
    render() {
        return (
            <TeamWeek />
        )
    }
}

export default TeamWeekForm;